import Style from "../style/userWallet.module.scss"
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import TransactionBox from "../component/TransactionBox";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authAxios from "../../../../config/authAxios";
import Skeleton from '@mui/material/Skeleton';
import BottomBar from "../component/BottomBar";



const TransactionHistory = () => {
  const [alltabs, setAllTabs] = useState([{ name: "All", value: 1 }, { name: "Credited", value: 2 }, { name: "Debited", value: 3 }])
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0);
  const handleTabCLick = (e) => {
    if(activeTab == e){
      return
    }
    setActiveTab(e)
    setTransactions([]);
    setPage(0);
  }
  const navigate = useNavigate()

  const [transactions, setTransactions] = useState([])

  const fetchTransaction = async (activeTab, page) => {
    try {
      setLoading(true)
      const response = await authAxios.get(`/users/api/fetch-transaction/${activeTab}/${page}/5`);
      setHasMore(response?.data?.data.length >= 5)
      setTransactions((prev) => [...prev, ...response?.data?.data])
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTransaction(activeTab, page);
  }, [activeTab, page]);



  return (
    <>
      <div className={Style.box_container}>
        <div className={Style.wallet_container}>
          <div onClick={() => navigate(-1)}>
            <BackArrow />
          </div>

          <QuizWallicon width={143} height={31} />
        </div>

        <div className={Style.wallet_bottom_container}>
          <div className={Style.paddinLeft}>
            <div className={Style.tabFlex}>


              {alltabs?.map((e) => {
                return <React.Fragment key={e.value}>
                  <div className={Style.tabBox} onClick={() => handleTabCLick(e?.value)} style={{ background: activeTab == e.value ? "#FA5743" : "#fff" }}>
                    <p className={Style.tabBoxText} style={{ color: activeTab == e.value ? "#fff" : "#FA5743" }}>{e.name}</p>
                  </div>
                </React.Fragment>
              })}
            </div>
          </div>

          <div className={Style.box3}>
            <p className={Style.wallet_text11}>Transaction history</p>
          </div>
          <div className={Style.paddinLeft}>
            {transactions?.length > 0 ?  transactions.map((e, index) => (
              <TransactionBox key={index} data={e} />
            )) : 
            <div className={Style.noHistoryCover}>

            
            <div className={Style.noHistory}><h3>No Transactions Found</h3></div>
            </div>
            
            } 
            {loading && (
              new Array(6).fill(1).map((ele, i) => <Skeleton key={i} style={{ borderRadius: "16px", marginBottom: "12px" }} animation="wave" variant="rectangular" width={"100%"} height={54} />)
            )}
          </div>
          {hasMore &&
            <div onClick={() => setPage(page + 1)} className={Style.load_more_box}><p className={Style.load_more}>Load More</p></div>
          }
        </div>
        <BottomBar />
      </div>
    </>
  )
}

export default TransactionHistory;